import {
  IProjectVersionAttributes,
} from '@SiteModules/ProjectVersion/types'

export type ProjectVersionDisplayKind = 'source' | 'pending_clip' | 'ready_clip'

// Determines how a project version should be presented in the versions/clips list.
//
// - `source`: the original long video the clips are generated from.
// - `pending_clip`: a generated clip that the backend is still crafting. New clip
//   project versions are persisted with `unformattedDuration === 0` while they are
//   being rendered, so a repurposed version with no real duration is still pending.
// - `ready_clip`: a generated clip that has finished rendering and is usable.
export default function getProjectVersionDisplayKind(
  attributes: Pick<IProjectVersionAttributes, 'isRepurposed' | 'unformattedDuration'>
): ProjectVersionDisplayKind {
  if (!attributes.isRepurposed) {
    return 'source'
  }

  if (!attributes.unformattedDuration || attributes.unformattedDuration <= 0) {
    return 'pending_clip'
  }

  return 'ready_clip'
}
